export default {
  //
  data: {},
  date: null
}
